<template>
  <el-timeline-item
    :timestamp="notificationDetail.createTime | convertToLabelFilter"
    placement="top"
    :icon="isSeen ? 'fas fa-bell color__green' : ''"
  >
    <el-card class="notification-timeline-item">
      <vb-notification-item
        :notificationDetail="notificationDetail"
        @click="itemClicked"
      >
      </vb-notification-item>
    </el-card>
  </el-timeline-item>
</template>

<script>
  import DocNotificationItemTemplate from "../common/layout/doc-notification-item-template";
  import VbNotificationItem from "./vb-notification-item";
  import convertToLabelFilter from "../../filters/convertToLabelFilter";

  export default {
    name: "vb-notification-timeline-item",
    props: ["notificationDetail"],
    components: {VbNotificationItem, DocNotificationItemTemplate},
    filters: {convertToLabelFilter},
    computed: {
      isSeen() {
        return this.notificationDetail.status === "unSeen";
      }
    },
    methods: {
      itemClicked() {
        this.notificationDetail.status = "seen";
        this.$emit("click", {notificationDetail: this.notificationDetail});
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/dashboard/vb-notification-timeline-item.vue